import { useQuery } from '@tanstack/react-query';
import type { ActivityPageDTO } from '../api/types';
import { useContext } from './hooks';

/** Startup, stream updates and read-marker receipts share this exact observed key. */
export function useActivityCount() {
  const { runtime, available } = useContext();
  return useQuery({ queryKey: runtime.key('activityCount'), enabled: available, staleTime: 30_000, retry: false,
    queryFn: async ({ signal }) => (await runtime.read<ActivityPageDTO>('/activity', { limit: 1 }, signal)).unread_count });
}
